import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { leaveSession } from '../../../utilis/session-redirect';

// Hands the user off as soon as the backend reports the post stage. Nothing
// gates this any more: end-of-session feedback moved to the post-performance
// screen, so there is no popup left on the exercise page to wait for.
const usePostPerformance = ({ closeCameraAfterNavigate, isPostStage, completeUrl }) => {
  const navigate = useNavigate();
  const hasNavigatedRef = useRef(false);
  // The redirect runs from an effect that must not re-fire on every render, so
  // the latest URL / cleanup callback are read through refs rather than being
  // dependencies (closeCameraAfterNavigate is re-created every render).
  const completeUrlRef = useRef(completeUrl);
  completeUrlRef.current = completeUrl;
  const closeCameraRef = useRef(closeCameraAfterNavigate);
  closeCameraRef.current = closeCameraAfterNavigate;

  useEffect(() => {
    if (!isPostStage) {
      hasNavigatedRef.current = false;
      return;
    }

    if (hasNavigatedRef.current) {
      return;
    }

    hasNavigatedRef.current = true;
    closeCameraRef.current?.();
    // Session finished: hand the user back to whatever launched it. Without a
    // completeUrl there's no external destination, so step one entry back in
    // history instead.
    leaveSession({ url: completeUrlRef.current, navigate });
  }, [isPostStage, navigate]);
};

export default usePostPerformance;

// useEffect(() => {
//   if (postPerformance && postData) {
//     // when set it to last code for make them together the frontend timer bug in backend and when save to local storage
//     handleSetToLocalForage();
//   }
// }, [postData, postPerformance]);

// const handleSetToLocalForage = async () => {
//   // Save the video blob to IndexedDB
//   try {
//     setPostChunks(chunks);
//     // await localforage.setItem("recordedVideo", chunks);
//     const frontEnd_timer = JSON.parse(localStorage.getItem("frontend_timer"));
//     let fullRecordingTime;
//     if (parseInitialMovement?.movement === Exercises.yoga) {
//       const YogaFullResetTime = localStorage.getItem("fullFeedTime"); // full blurring timer
//       fullRecordingTime = Number(frontEnd_timer) - Number(YogaFullResetTime);
//     } else {
//       fullRecordingTime = frontEnd_timer - state.fullResetTime;
//     }
//     cleanupStream(); // clear and stop streaming
//     localStorage.setItem("frontend_timer", fullRecordingTime);
//   } catch (err) {
//     console.error("Failed to save video to IndexedDB", err);
//   }
// };
